import type { RouteProps } from 'react-router';
import { useAppContext } from '../../react/hooks/useAppContext';
import confirmIdentity from '../../react/services/ConfirmIdentity';
import PageRoute from '../PageRoute';

/**
 * We don't support Route content via "children" or "component" because we only intercept "render".
 */
type Props = Omit<RouteProps, 'children' | 'component'>;

export default function ConfirmIdentityRoute({ render, ...otherProps }: Props) {
    const { user } = useAppContext();
    return (
        <PageRoute
            {...otherProps}
            render={
                user.secureLogin
                    ? render
                    : () => {
                          confirmIdentity();
                          return undefined;
                      }
            }
        />
    );
}
